import PumpList from "./pages/ListPage.vue";
import PumpDetail from "./pages/FormPage.vue";
import PumpIndex from "./pages/IndexPage.vue";

export default [
  {
    path: "/pump",
    component: PumpIndex,
    redirect: "/pump/list",
    name: "pump",
    children: [
      {
        path: "list",
        component: PumpList,
        name: "pump.list",
      },
      {
        path: "create",
        component: PumpDetail,
        name: "pump.create",
        props: { create: true },
      },
      {
        path: "edit/:id",
        component: PumpDetail,
        name: "pump.edit",
        props: { create: false },
      },
    ],
  },
];
